import { styled } from 'styled-components';

export const Container = styled.div`
  flex: 1;
  min-width: 0;
  overflow: hidden;
`;
